/* eslint-disable */
  // Do not edit this directly !!!!!!!!!!!!!!!
  // File was generated using API/scripts/build_permission_tree.js
  // To recreate go to /API and type npm run buildpermissions

  import _ from 'lodash'
  export const TestPermission = function (list, permission) {
    if (_.startsWith(permission, 'ANY:')) {
      const permParts = permission.split(':')
      return _.filter(list, (p) => { return _.startsWith(p, permParts[1]) }).length > 0
    } else {
      return _.find(list, (p) => { return p === permission }) === permission
    }
  }
  export const TestPermissions = function (list, permissions, requireAll = false) {
    if (permissions.length === 0) {
      return true
    }

    if (requireAll) {
      let matchCount = 0
      for(var perm of permissions) {
        isMatch = TestPermission(list, perm)
        if (isMatch === true) {
          matchCount++
        }
      }
      return permissions.length == matchCount
    } else {
      let isMatch = false
      for(var perm of permissions) {
        isMatch = TestPermission(list, perm)
        if (isMatch === true) {
          break
        }
      }
      return isMatch
    }
  }
  export const Permissions = {
  APP: {
    ANY: 'ANY:APP',
    AGENCY: {
      ANY: 'ANY:APP.AGENCY',
      CONTRACTS: {
        ANY: 'ANY:APP.AGENCY.CONTRACTS',
        VIEW: 'APP.AGENCY.CONTRACTS.VIEW',
        EDIT: 'APP.AGENCY.CONTRACTS.EDIT'
      },
      PAYMENTOPTIONS: {
        ANY: 'ANY:APP.AGENCY.PAYMENTOPTIONS',
        ADD: 'APP.AGENCY.PAYMENTOPTIONS.ADD',
        DELETE: 'APP.AGENCY.PAYMENTOPTIONS.DELETE',
        VIEW: 'APP.AGENCY.PAYMENTOPTIONS.VIEW'
      },
      INVOICES: {
        ANY: 'ANY:APP.AGENCY.INVOICES',
        VIEW: 'APP.AGENCY.INVOICES.VIEW',
        EDIT: 'APP.AGENCY.INVOICES.EDIT'
      }
    },
    MANAGE: {
      ANY: 'ANY:APP.MANAGE',
      ROLES: {
        ANY: 'ANY:APP.MANAGE.ROLES',
        VIEW: 'APP.MANAGE.ROLES.VIEW',
        ADD: 'APP.MANAGE.ROLES.ADD',
        EDIT: 'APP.MANAGE.ROLES.EDIT',
        DELETE: 'APP.MANAGE.ROLES.DELETE',
        PERMISSIONS: {
          ANY: 'ANY:APP.MANAGE.ROLES.PERMISSIONS',
          MANAGE: 'APP.MANAGE.ROLES.PERMISSIONS.MANAGE'
        },
        DOCUMENTSETS: {
          ANY: 'ANY:APP.MANAGE.ROLES.DOCUMENTSETS',
          MANAGE: 'APP.MANAGE.ROLES.DOCUMENTSETS.MANAGE'
        }
      },
      USERS: {
        ANY: 'ANY:APP.MANAGE.USERS',
        VIEW: 'APP.MANAGE.USERS.VIEW',
        ADD: 'APP.MANAGE.USERS.ADD',
        EDIT: 'APP.MANAGE.USERS.EDIT',
        REVOKEINVITE: 'APP.MANAGE.USERS.REVOKEINVITE',
        DOCUMENTS: {
          ANY: 'ANY:APP.MANAGE.USERS.DOCUMENTS',
          VIEW: 'APP.MANAGE.USERS.DOCUMENTS.VIEW',
          REVIEW: 'APP.MANAGE.USERS.DOCUMENTS.REVIEW'
        }
      },
      BRANCHES: {
        ANY: 'ANY:APP.MANAGE.BRANCHES',
        VIEW: 'APP.MANAGE.BRANCHES.VIEW',
        ADD: 'APP.MANAGE.BRANCHES.ADD',
        EDIT: 'APP.MANAGE.BRANCHES.EDIT',
        DELETE: 'APP.MANAGE.BRANCHES.DELETE',
        KEYS: {
          ANY: 'ANY:APP.MANAGE.BRANCHES.KEYS',
          VIEW: 'APP.MANAGE.BRANCHES.KEYS.VIEW',
          ADD: 'APP.MANAGE.BRANCHES.KEYS.ADD',
          EDIT: 'APP.MANAGE.BRANCHES.KEYS.EDIT',
          DELETE: 'APP.MANAGE.BRANCHES.KEYS.DELETE'
        },
        CHANNELS: {
          ANY: 'ANY:APP.MANAGE.BRANCHES.CHANNELS',
          VIEW: 'APP.MANAGE.BRANCHES.CHANNELS.VIEW',
          ADD: 'APP.MANAGE.BRANCHES.CHANNELS.ADD',
          EDIT: 'APP.MANAGE.BRANCHES.CHANNELS.EDIT',
          DELETE: 'APP.MANAGE.BRANCHES.CHANNELS.DELETE'
        },
        ADDRESS: {
          ANY: 'ANY:APP.MANAGE.BRANCHES.ADDRESS',
          VIEW: 'APP.MANAGE.BRANCHES.ADDRESS.VIEW',
          ADD: 'APP.MANAGE.BRANCHES.ADDRESS.ADD',
          EDIT: 'APP.MANAGE.BRANCHES.ADDRESS.EDIT',
          DELETE: 'APP.MANAGE.BRANCHES.ADDRESS.DELETE'
        }
      },
      PAYROLL: {
        ANY: 'ANY:APP.MANAGE.PAYROLL',
        PROCESS: 'APP.MANAGE.PAYROLL.PROCESS'
      },
      LOOKUPS: {
        ANY: 'ANY:APP.MANAGE.LOOKUPS',
        VIEW: 'APP.MANAGE.LOOKUPS.VIEW',
        MANAGE: 'APP.MANAGE.LOOKUPS.MANAGE',
        DELETE: 'APP.MANAGE.LOOKUPS.DELETE'
      },
      CAHPSVENDORS: {
        ANY: 'ANY:APP.MANAGE.CAHPSVENDORS',
        ADD: 'APP.MANAGE.CAHPSVENDORS.ADD',
        VIEW: 'APP.MANAGE.CAHPSVENDORS.VIEW',
        EDIT: 'APP.MANAGE.CAHPSVENDORS.EDIT',
        DELETE: 'APP.MANAGE.CAHPSVENDORS.DELETE'
      },
      PHYSICIANS: {
        ANY: 'ANY:APP.MANAGE.PHYSICIANS',
        VIEW: 'APP.MANAGE.PHYSICIANS.VIEW',
        ADD: 'APP.MANAGE.PHYSICIANS.ADD',
        EDIT: 'APP.MANAGE.PHYSICIANS.EDIT',
        DELETE: 'APP.MANAGE.PHYSICIANS.DELETE',
        CHANNELS: {
          ANY: 'ANY:APP.MANAGE.PHYSICIANS.CHANNELS',
          VIEW: 'APP.MANAGE.PHYSICIANS.CHANNELS.VIEW',
          ADD: 'APP.MANAGE.PHYSICIANS.CHANNELS.ADD',
          EDIT: 'APP.MANAGE.PHYSICIANS.CHANNELS.EDIT',
          DELETE: 'APP.MANAGE.PHYSICIANS.CHANNELS.DELETE'
        },
        ADDRESS: {
          ANY: 'ANY:APP.MANAGE.PHYSICIANS.ADDRESS',
          VIEW: 'APP.MANAGE.PHYSICIANS.ADDRESS.VIEW',
          ADD: 'APP.MANAGE.PHYSICIANS.ADDRESS.ADD',
          EDIT: 'APP.MANAGE.PHYSICIANS.ADDRESS.EDIT',
          DELETE: 'APP.MANAGE.PHYSICIANS.ADDRESS.DELETE'
        }
      },
      CONTRACTORS: {
        ANY: 'ANY:APP.MANAGE.CONTRACTORS',
        VIEW: 'APP.MANAGE.CONTRACTORS.VIEW',
        ADD: 'APP.MANAGE.CONTRACTORS.ADD',
        EDIT: 'APP.MANAGE.CONTRACTORS.EDIT',
        DELETE: 'APP.MANAGE.CONTRACTORS.DELETE',
        CHANNELS: {
          ANY: 'ANY:APP.MANAGE.CONTRACTORS.CHANNELS',
          VIEW: 'APP.MANAGE.CONTRACTORS.CHANNELS.VIEW',
          ADD: 'APP.MANAGE.CONTRACTORS.CHANNELS.ADD',
          EDIT: 'APP.MANAGE.CONTRACTORS.CHANNELS.EDIT',
          DELETE: 'APP.MANAGE.CONTRACTORS.CHANNELS.DELETE'
        },
        ADDRESS: {
          ANY: 'ANY:APP.MANAGE.CONTRACTORS.ADDRESS',
          VIEW: 'APP.MANAGE.CONTRACTORS.ADDRESS.VIEW',
          ADD: 'APP.MANAGE.CONTRACTORS.ADDRESS.ADD',
          EDIT: 'APP.MANAGE.CONTRACTORS.ADDRESS.EDIT',
          DELETE: 'APP.MANAGE.CONTRACTORS.ADDRESS.DELETE'
        }
      },
      SERVICECENTERS: {
        ANY: 'ANY:APP.MANAGE.SERVICECENTERS',
        VIEW: 'APP.MANAGE.SERVICECENTERS.VIEW',
        ADD: 'APP.MANAGE.SERVICECENTERS.ADD',
        EDIT: 'APP.MANAGE.SERVICECENTERS.EDIT',
        DELETE: 'APP.MANAGE.SERVICECENTERS.DELETE',
        CHANNELS: {
          ANY: 'ANY:APP.MANAGE.SERVICECENTERS.CHANNELS',
          VIEW: 'APP.MANAGE.SERVICECENTERS.CHANNELS.VIEW',
          ADD: 'APP.MANAGE.SERVICECENTERS.CHANNELS.ADD',
          EDIT: 'APP.MANAGE.SERVICECENTERS.CHANNELS.EDIT',
          DELETE: 'APP.MANAGE.SERVICECENTERS.CHANNELS.DELETE'
        },
        ADDRESS: {
          ANY: 'ANY:APP.MANAGE.SERVICECENTERS.ADDRESS',
          VIEW: 'APP.MANAGE.SERVICECENTERS.ADDRESS.VIEW',
          ADD: 'APP.MANAGE.SERVICECENTERS.ADDRESS.ADD',
          EDIT: 'APP.MANAGE.SERVICECENTERS.ADDRESS.EDIT',
          DELETE: 'APP.MANAGE.SERVICECENTERS.ADDRESS.DELETE'
        }
      },
      PAYERS: {
        ANY: 'ANY:APP.MANAGE.PAYERS',
        VIEW: 'APP.MANAGE.PAYERS.VIEW',
        ADD: 'APP.MANAGE.PAYERS.ADD',
        EDIT: 'APP.MANAGE.PAYERS.EDIT',
        DELETE: 'APP.MANAGE.PAYERS.DELETE'
      },
      RECEIVERS: {
        ANY: 'ANY:APP.MANAGE.RECEIVERS',
        VIEW: 'APP.MANAGE.RECEIVERS.VIEW',
        ADD: 'APP.MANAGE.RECEIVERS.ADD',
        EDIT: 'APP.MANAGE.RECEIVERS.EDIT',
        DELETE: 'APP.MANAGE.RECEIVERS.DELETE'
      }
    },
    PATIENTS: {
      ANY: 'ANY:APP.PATIENTS',
      PATIENT: {
        ANY: 'ANY:APP.PATIENTS.PATIENT',
        ADD: 'APP.PATIENTS.PATIENT.ADD',
        VIEW: 'APP.PATIENTS.PATIENT.VIEW',
        EDIT: 'APP.PATIENTS.PATIENT.EDIT',
        DELETE: 'APP.PATIENTS.PATIENT.DELETE',
        ADDRESS: {
          ANY: 'ANY:APP.PATIENTS.PATIENT.ADDRESS',
          ADD: 'APP.PATIENTS.PATIENT.ADDRESS.ADD',
          VIEW: 'APP.PATIENTS.PATIENT.ADDRESS.VIEW',
          EDIT: 'APP.PATIENTS.PATIENT.ADDRESS.EDIT',
          DELETE: 'APP.PATIENTS.PATIENT.ADDRESS.DELETE'
        }
      },
      MEDICATIONS: {
        ANY: 'ANY:APP.PATIENTS.MEDICATIONS',
        ADD: 'APP.PATIENTS.MEDICATIONS.ADD',
        VIEW: 'APP.PATIENTS.MEDICATIONS.VIEW',
        EDIT: 'APP.PATIENTS.MEDICATIONS.EDIT',
        DELETE: 'APP.PATIENTS.MEDICATIONS.DELETE'
      },
      PHARMACIES: {
        ANY: 'ANY:APP.PATIENTS.PHARMACIES',
        ADD: 'APP.PATIENTS.PHARMACIES.ADD',
        VIEW: 'APP.PATIENTS.PHARMACIES.VIEW',
        EDIT: 'APP.PATIENTS.PHARMACIES.EDIT',
        DELETE: 'APP.PATIENTS.PHARMACIES.DELETE'
      },
      EPISODES: {
        ANY: 'ANY:APP.PATIENTS.EPISODES',
        ADD: 'APP.PATIENTS.EPISODES.ADD',
        VIEW: 'APP.PATIENTS.EPISODES.VIEW',
        EDIT: 'APP.PATIENTS.EPISODES.EDIT',
        DELETE: 'APP.PATIENTS.EPISODES.DELETE',
        FREQUENCY: {
          ANY: 'ANY:APP.PATIENTS.EPISODES.FREQUENCY',
          ADD: 'APP.PATIENTS.EPISODES.FREQUENCY.ADD',
          VIEW: 'APP.PATIENTS.EPISODES.FREQUENCY.VIEW',
          EDIT: 'APP.PATIENTS.EPISODES.FREQUENCY.EDIT',
          DELETE: 'APP.PATIENTS.EPISODES.FREQUENCY.DELETE'
        },
        AUTHORIZATION: {
          ANY: 'ANY:APP.PATIENTS.EPISODES.AUTHORIZATION',
          ADD: 'APP.PATIENTS.EPISODES.AUTHORIZATION.ADD',
          VIEW: 'APP.PATIENTS.EPISODES.AUTHORIZATION.VIEW',
          EDIT: 'APP.PATIENTS.EPISODES.AUTHORIZATION.EDIT',
          DELETE: 'APP.PATIENTS.EPISODES.AUTHORIZATION.DELETE'
        },
        OASISEXPORTS: {
          ANY: 'ANY:APP.PATIENTS.EPISODES.OASISEXPORTS',
          UPDATE: 'APP.PATIENTS.EPISODES.OASISEXPORTS.UPDATE'
        }
      },
      CHARTS: {
        ANY: 'ANY:APP.PATIENTS.CHARTS',
        ADD: 'APP.PATIENTS.CHARTS.ADD',
        VIEW: 'APP.PATIENTS.CHARTS.VIEW',
        EDIT: 'APP.PATIENTS.CHARTS.EDIT',
        DELETE: 'APP.PATIENTS.CHARTS.DELETE'
      },
      INTAKES: {
        ANY: 'ANY:APP.PATIENTS.INTAKES',
        ADD: 'APP.PATIENTS.INTAKES.ADD',
        VIEW: 'APP.PATIENTS.INTAKES.VIEW',
        EDIT: 'APP.PATIENTS.INTAKES.EDIT',
        DELETE: 'APP.PATIENTS.INTAKES.DELETE'
      },
      VISITS: {
        ANY: 'ANY:APP.PATIENTS.VISITS',
        ADD: 'APP.PATIENTS.VISITS.ADD',
        VIEW: 'APP.PATIENTS.VISITS.VIEW',
        EDIT: 'APP.PATIENTS.VISITS.EDIT',
        DELETE: 'APP.PATIENTS.VISITS.DELETE'
      },
      DOCUMENTS: {
        ANY: 'ANY:APP.PATIENTS.DOCUMENTS',
        VIEW: 'APP.PATIENTS.DOCUMENTS.VIEW',
        PRINT: 'APP.PATIENTS.DOCUMENTS.PRINT'
      },
      BILLINGLEDGERS: {
        ANY: 'ANY:APP.PATIENTS.BILLINGLEDGERS',
        ADD: 'APP.PATIENTS.BILLINGLEDGERS.ADD',
        VIEW: 'APP.PATIENTS.BILLINGLEDGERS.VIEW',
        EDIT: 'APP.PATIENTS.BILLINGLEDGERS.EDIT',
        DELETE: 'APP.PATIENTS.BILLINGLEDGERS.DELETE'
      }
    },
    TOOLS: {
      ANY: 'ANY:APP.TOOLS',
      AUDIT: {
        ANY: 'ANY:APP.TOOLS.AUDIT',
        VIEW: 'APP.TOOLS.AUDIT.VIEW'
      },
      MANAGER: 'APP.TOOLS.MANAGER',
      OASISEXPORTS: {
        ANY: 'ANY:APP.TOOLS.OASISEXPORTS',
        UPDATE: 'APP.TOOLS.OASISEXPORTS.UPDATE'
      },
      MARKETPLACE: {
        ANY: 'ANY:APP.TOOLS.MARKETPLACE',
        ADD: 'APP.TOOLS.MARKETPLACE.ADD',
        VIEW: 'APP.TOOLS.MARKETPLACE.VIEW',
        DELETE: 'APP.TOOLS.MARKETPLACE.DELETE',
        EDIT: 'APP.TOOLS.MARKETPLACE.EDIT'
      },
      CAHPSEXPORT: {
        ANY: 'ANY:APP.TOOLS.CAHPSEXPORT',
        ADD: 'APP.TOOLS.CAHPSEXPORT.ADD',
        VIEW: 'APP.TOOLS.CAHPSEXPORT.VIEW',
        DELETE: 'APP.TOOLS.CAHPSEXPORT.DELETE',
        EDIT: 'APP.TOOLS.CAHPSEXPORT.EDIT'
      },
      CAHPS: 'APP.TOOLS.CAHPS',
      DOCUMENTTRACKING: {
        ANY: 'ANY:APP.TOOLS.DOCUMENTTRACKING',
        ADD: 'APP.TOOLS.DOCUMENTTRACKING.ADD',
        VIEW: 'APP.TOOLS.DOCUMENTTRACKING.VIEW',
        DELETE: 'APP.TOOLS.DOCUMENTTRACKING.DELETE',
        EDIT: 'APP.TOOLS.DOCUMENTTRACKING.EDIT'
      },
      CLAIMS: {
        ANY: 'ANY:APP.TOOLS.CLAIMS',
        ADD: 'APP.TOOLS.CLAIMS.ADD',
        VIEW: 'APP.TOOLS.CLAIMS.VIEW',
        DELETE: 'APP.TOOLS.CLAIMS.DELETE',
        EDIT: 'APP.TOOLS.CLAIMS.EDIT'
      },
      QADOCUMENTS: {
        ANY: 'ANY:APP.TOOLS.QADOCUMENTS',
        VIEW: 'APP.TOOLS.QADOCUMENTS.VIEW',
        EDIT: 'APP.TOOLS.QADOCUMENTS.EDIT'
      },
      BATCHPOSTING: 'APP.TOOLS.BATCHPOSTING',
      DATAIMPORT: 'APP.TOOLS.DATAIMPORT',
      EVENTMANAGER: {
        ANY: 'ANY:APP.TOOLS.EVENTMANAGER',
        VIEW: 'APP.TOOLS.EVENTMANAGER.VIEW',
        DELETE: 'APP.TOOLS.EVENTMANAGER.DELETE',
        EDIT: 'APP.TOOLS.EVENTMANAGER.EDIT'
      },
      DATAIMPORT: 'APP.TOOLS.DATAIMPORT',
    },
    ALL: [
      'APP.AGENCY.CONTRACTS.VIEW',
      'APP.AGENCY.CONTRACTS.EDIT',
      'APP.AGENCY.PAYMENTOPTIONS.ADD',
      'APP.AGENCY.PAYMENTOPTIONS.DELETE',
      'APP.AGENCY.PAYMENTOPTIONS.VIEW',
      'APP.AGENCY.INVOICES.VIEW',
      'APP.AGENCY.INVOICES.EDIT',
      'APP.MANAGE.ROLES.VIEW',
      'APP.MANAGE.ROLES.ADD',
      'APP.MANAGE.ROLES.EDIT',
      'APP.MANAGE.ROLES.DELETE',
      'APP.MANAGE.ROLES.PERMISSIONS.MANAGE',
      'APP.MANAGE.ROLES.DOCUMENTSETS.MANAGE',
      'APP.MANAGE.USERS.VIEW',
      'APP.MANAGE.USERS.ADD',
      'APP.MANAGE.USERS.EDIT',
      'APP.MANAGE.USERS.REVOKEINVITE',
      'APP.MANAGE.USERS.DOCUMENTS.VIEW',
      'APP.MANAGE.USERS.DOCUMENTS.REVIEW',
      'APP.MANAGE.BRANCHES.VIEW',
      'APP.MANAGE.BRANCHES.ADD',
      'APP.MANAGE.BRANCHES.EDIT',
      'APP.MANAGE.BRANCHES.DELETE',
      'APP.MANAGE.BRANCHES.KEYS.VIEW',
      'APP.MANAGE.BRANCHES.KEYS.ADD',
      'APP.MANAGE.BRANCHES.KEYS.EDIT',
      'APP.MANAGE.BRANCHES.KEYS.DELETE',
      'APP.MANAGE.BRANCHES.CHANNELS.VIEW',
      'APP.MANAGE.BRANCHES.CHANNELS.ADD',
      'APP.MANAGE.BRANCHES.CHANNELS.EDIT',
      'APP.MANAGE.BRANCHES.CHANNELS.DELETE',
      'APP.MANAGE.BRANCHES.ADDRESS.VIEW',
      'APP.MANAGE.BRANCHES.ADDRESS.ADD',
      'APP.MANAGE.BRANCHES.ADDRESS.EDIT',
      'APP.MANAGE.BRANCHES.ADDRESS.DELETE',
      'APP.MANAGE.PAYROLL.PROCESS',
      'APP.MANAGE.LOOKUPS.VIEW',
      'APP.MANAGE.LOOKUPS.MANAGE',
      'APP.MANAGE.LOOKUPS.DELETE',
      'APP.MANAGE.CAHPSVENDORS.ADD',
      'APP.MANAGE.CAHPSVENDORS.VIEW',
      'APP.MANAGE.CAHPSVENDORS.EDIT',
      'APP.MANAGE.CAHPSVENDORS.DELETE',
      'APP.PATIENTS.PATIENT.ADD',
      'APP.PATIENTS.PATIENT.VIEW',
      'APP.PATIENTS.PATIENT.EDIT',
      'APP.PATIENTS.PATIENT.DELETE',
      'APP.PATIENTS.PATIENT.ADDRESS.ADD',
      'APP.PATIENTS.PATIENT.ADDRESS.VIEW',
      'APP.PATIENTS.PATIENT.ADDRESS.EDIT',
      'APP.PATIENTS.PATIENT.ADDRESS.DELETE',
      'APP.PATIENTS.MEDICATIONS.ADD',
      'APP.PATIENTS.MEDICATIONS.VIEW',
      'APP.PATIENTS.MEDICATIONS.EDIT',
      'APP.PATIENTS.MEDICATIONS.DELETE',
      'APP.PATIENTS.PHARMACIES.ADD',
      'APP.PATIENTS.PHARMACIES.VIEW',
      'APP.PATIENTS.PHARMACIES.EDIT',
      'APP.PATIENTS.PHARMACIES.DELETE',
      'APP.PATIENTS.EPISODES.ADD',
      'APP.PATIENTS.EPISODES.VIEW',
      'APP.PATIENTS.EPISODES.EDIT',
      'APP.PATIENTS.EPISODES.DELETE',
      'APP.PATIENTS.EPISODES.FREQUENCY.ADD',
      'APP.PATIENTS.EPISODES.FREQUENCY.VIEW',
      'APP.PATIENTS.EPISODES.FREQUENCY.EDIT',
      'APP.PATIENTS.EPISODES.FREQUENCY.DELETE',
      'APP.PATIENTS.EPISODES.AUTHORIZATION.ADD',
      'APP.PATIENTS.EPISODES.AUTHORIZATION.VIEW',
      'APP.PATIENTS.EPISODES.AUTHORIZATION.EDIT',
      'APP.PATIENTS.EPISODES.AUTHORIZATION.DELETE',
      'APP.PATIENTS.CHARTS.ADD',
      'APP.PATIENTS.CHARTS.VIEW',
      'APP.PATIENTS.CHARTS.EDIT',
      'APP.PATIENTS.CHARTS.DELETE',
      'APP.PATIENTS.INTAKES.ADD',
      'APP.PATIENTS.INTAKES.VIEW',
      'APP.PATIENTS.INTAKES.EDIT',
      'APP.PATIENTS.INTAKES.DELETE',
      'APP.PATIENTS.VISITS.ADD',
      'APP.PATIENTS.VISITS.VIEW',
      'APP.PATIENTS.VISITS.EDIT',
      'APP.PATIENTS.VISITS.DELETE',
      'APP.PATIENTS.DOCUMENTS.VIEW',
      'APP.PATIENTS.DOCUMENTS.PRINT',
      'APP.PATIENTS.EPISODES.OASISEXPORTS.UPDATE',
      'APP.PATIENTS.BILLINGLEDGERS.ADD',
      'APP.PATIENTS.BILLINGLEDGERS.VIEW',
      'APP.PATIENTS.BILLINGLEDGERS.EDIT',
      'APP.PATIENTS.BILLINGLEDGERS.DELETE',
      'APP.MANAGE.PHYSICIANS.VIEW',
      'APP.MANAGE.PHYSICIANS.ADD',
      'APP.MANAGE.PHYSICIANS.EDIT',
      'APP.MANAGE.PHYSICIANS.DELETE',
      'APP.MANAGE.PHYSICIANS.CHANNELS.VIEW',
      'APP.MANAGE.PHYSICIANS.CHANNELS.ADD',
      'APP.MANAGE.PHYSICIANS.CHANNELS.EDIT',
      'APP.MANAGE.PHYSICIANS.CHANNELS.DELETE',
      'APP.MANAGE.PHYSICIANS.ADDRESS.VIEW',
      'APP.MANAGE.PHYSICIANS.ADDRESS.ADD',
      'APP.MANAGE.PHYSICIANS.ADDRESS.EDIT',
      'APP.MANAGE.PHYSICIANS.ADDRESS.DELETE',
      'APP.MANAGE.CONTRACTORS.VIEW',
      'APP.MANAGE.CONTRACTORS.ADD',
      'APP.MANAGE.CONTRACTORS.EDIT',
      'APP.MANAGE.CONTRACTORS.DELETE',
      'APP.MANAGE.CONTRACTORS.CHANNELS.VIEW',
      'APP.MANAGE.CONTRACTORS.CHANNELS.ADD',
      'APP.MANAGE.CONTRACTORS.CHANNELS.EDIT',
      'APP.MANAGE.CONTRACTORS.CHANNELS.DELETE',
      'APP.MANAGE.CONTRACTORS.ADDRESS.VIEW',
      'APP.MANAGE.CONTRACTORS.ADDRESS.ADD',
      'APP.MANAGE.CONTRACTORS.ADDRESS.EDIT',
      'APP.MANAGE.CONTRACTORS.ADDRESS.DELETE',
      'APP.MANAGE.SERVICECENTERS.VIEW',
      'APP.MANAGE.SERVICECENTERS.ADD',
      'APP.MANAGE.SERVICECENTERS.EDIT',
      'APP.MANAGE.SERVICECENTERS.DELETE',
      'APP.MANAGE.SERVICECENTERS.CHANNELS.VIEW',
      'APP.MANAGE.SERVICECENTERS.CHANNELS.ADD',
      'APP.MANAGE.SERVICECENTERS.CHANNELS.EDIT',
      'APP.MANAGE.SERVICECENTERS.CHANNELS.DELETE',
      'APP.MANAGE.SERVICECENTERS.ADDRESS.VIEW',
      'APP.MANAGE.SERVICECENTERS.ADDRESS.ADD',
      'APP.MANAGE.SERVICECENTERS.ADDRESS.EDIT',
      'APP.MANAGE.SERVICECENTERS.ADDRESS.DELETE',
      'APP.MANAGE.PAYERS.VIEW',
      'APP.MANAGE.PAYERS.ADD',
      'APP.MANAGE.PAYERS.EDIT',
      'APP.MANAGE.PAYERS.DELETE',
      'APP.MANAGE.RECEIVERS.VIEW',
      'APP.MANAGE.RECEIVERS.ADD',
      'APP.MANAGE.RECEIVERS.EDIT',
      'APP.MANAGE.RECEIVERS.DELETE',
      'APP.TOOLS.AUDIT.VIEW',
      'APP.TOOLS.MANAGER',
      'APP.TOOLS.OASISEXPORTS.UPDATE',
      'APP.TOOLS.MARKETPLACE.ADD',
      'APP.TOOLS.MARKETPLACE.VIEW',
      'APP.TOOLS.MARKETPLACE.DELETE',
      'APP.TOOLS.MARKETPLACE.EDIT',
      'APP.TOOLS.CAHPSEXPORT.ADD',
      'APP.TOOLS.CAHPSEXPORT.VIEW',
      'APP.TOOLS.CAHPSEXPORT.DELETE',
      'APP.TOOLS.CAHPSEXPORT.EDIT',
      'APP.TOOLS.CAHPS',
      'APP.TOOLS.DOCUMENTTRACKING.ADD',
      'APP.TOOLS.DOCUMENTTRACKING.VIEW',
      'APP.TOOLS.DOCUMENTTRACKING.DELETE',
      'APP.TOOLS.DOCUMENTTRACKING.EDIT',
      'APP.TOOLS.CLAIMS.ADD',
      'APP.TOOLS.CLAIMS.VIEW',
      'APP.TOOLS.CLAIMS.DELETE',
      'APP.TOOLS.CLAIMS.EDIT',
      'APP.TOOLS.QADOCUMENTS.VIEW',
      'APP.TOOLS.QADOCUMENTS.EDIT',
      'APP.TOOLS.BATCHPOSTING',
      'APP.TOOLS.DATAIMPORT',
      'APP.TOOLS.EVENTMANAGER.VIEW',
      'APP.TOOLS.EVENTMANAGER.DELETE',
      'APP.TOOLS.EVENTMANAGER.EDIT',
      'APP.TOOLS.DATAIMPORT'
    ]
  },
  ADMIN: {
    ANY: 'ANY:ADMIN',
    MANAGEACCESS: {
      ANY: 'ANY:ADMIN.MANAGEACCESS',
      AGENCIES: {
        ANY: 'ANY:ADMIN.MANAGEACCESS.AGENCIES',
        VIEW: 'ADMIN.MANAGEACCESS.AGENCIES.VIEW',
        ADD: 'ADMIN.MANAGEACCESS.AGENCIES.ADD',
        EDIT: 'ADMIN.MANAGEACCESS.AGENCIES.EDIT',
        DELETE: 'ADMIN.MANAGEACCESS.AGENCIES.DELETE',
        LICENSES: {
          ANY: 'ANY:ADMIN.MANAGEACCESS.AGENCIES.LICENSES',
          VIEW: 'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.VIEW',
          ADD: 'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.ADD',
          EDIT: 'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.EDIT',
          DELETE: 'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.DELETE'
        },
        CONTRACTS: {
          ANY: 'ANY:ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS',
          VIEW: 'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.VIEW',
          ADD: 'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.ADD',
          EDIT: 'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.EDIT',
          DELETE: 'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.DELETE'
        },
        INVOICES: {
          ANY: 'ANY:ADMIN.MANAGEACCESS.AGENCIES.INVOICES',
          VIEW: 'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.VIEW',
          ADD: 'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.ADD',
          EDIT: 'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.EDIT',
          DELETE: 'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.DELETE'
        }
      },
      ACCOUNTS: {
        ANY: 'ANY:ADMIN.MANAGEACCESS.ACCOUNTS',
        VIEW: 'ADMIN.MANAGEACCESS.ACCOUNTS.VIEW',
        ADD: 'ADMIN.MANAGEACCESS.ACCOUNTS.ADD',
        EDIT: 'ADMIN.MANAGEACCESS.ACCOUNTS.EDIT',
        DELETE: 'ADMIN.MANAGEACCESS.ACCOUNTS.DELETE',
        ROLES: {
          ANY: 'ANY:ADMIN.MANAGEACCESS.ACCOUNTS.ROLES',
          VIEW: 'ADMIN.MANAGEACCESS.ACCOUNTS.ROLES.VIEW',
          MANAGE: 'ADMIN.MANAGEACCESS.ACCOUNTS.ROLES.MANAGE'
        },
        SESSIONS: {
          ANY: 'ANY:ADMIN.MANAGEACCESS.ACCOUNTS.SESSIONS',
          VIEW: 'ADMIN.MANAGEACCESS.ACCOUNTS.SESSIONS.VIEW',
          MANAGE: 'ADMIN.MANAGEACCESS.ACCOUNTS.SESSIONS.MANAGE'
        }
      },
      ROLES: {
        ANY: 'ANY:ADMIN.MANAGEACCESS.ROLES',
        VIEW: 'ADMIN.MANAGEACCESS.ROLES.VIEW',
        ADD: 'ADMIN.MANAGEACCESS.ROLES.ADD',
        EDIT: 'ADMIN.MANAGEACCESS.ROLES.EDIT',
        DELETE: 'ADMIN.MANAGEACCESS.ROLES.DELETE'
      },
      PERMISSIONS: {
        ANY: 'ANY:ADMIN.MANAGEACCESS.PERMISSIONS',
        VIEW: 'ADMIN.MANAGEACCESS.PERMISSIONS.VIEW',
        MANAGE: 'ADMIN.MANAGEACCESS.PERMISSIONS.MANAGE',
        ADD: 'ADMIN.MANAGEACCESS.PERMISSIONS.ADD',
        EDIT: 'ADMIN.MANAGEACCESS.PERMISSIONS.EDIT'
      }
    },
    DATASETUP: {
      ANY: 'ANY:ADMIN.DATASETUP',
      COUNTRIES: {
        ANY: 'ANY:ADMIN.DATASETUP.COUNTRIES',
        VIEW: 'ADMIN.DATASETUP.COUNTRIES.VIEW',
        ADD: 'ADMIN.DATASETUP.COUNTRIES.ADD',
        EDIT: 'ADMIN.DATASETUP.COUNTRIES.EDIT',
        DELETE: 'ADMIN.DATASETUP.COUNTRIES.DELETE'
      },
      STATES: {
        ANY: 'ANY:ADMIN.DATASETUP.STATES',
        VIEW: 'ADMIN.DATASETUP.STATES.VIEW',
        ADD: 'ADMIN.DATASETUP.STATES.ADD',
        EDIT: 'ADMIN.DATASETUP.STATES.EDIT',
        DELETE: 'ADMIN.DATASETUP.STATES.DELETE'
      },
      TIMEZONES: {
        ANY: 'ANY:ADMIN.DATASETUP.TIMEZONES',
        VIEW: 'ADMIN.DATASETUP.TIMEZONES.VIEW',
        ADD: 'ADMIN.DATASETUP.TIMEZONES.ADD',
        EDIT: 'ADMIN.DATASETUP.TIMEZONES.EDIT',
        DELETE: 'ADMIN.DATASETUP.TIMEZONES.DELETE'
      },
      ZIPCODES: {
        ANY: 'ANY:ADMIN.DATASETUP.ZIPCODES',
        VIEW: 'ADMIN.DATASETUP.ZIPCODES.VIEW',
        ADD: 'ADMIN.DATASETUP.ZIPCODES.ADD',
        EDIT: 'ADMIN.DATASETUP.ZIPCODES.EDIT',
        DELETE: 'ADMIN.DATASETUP.ZIPCODES.DELETE'
      },
      ICD10: {
        ANY: 'ANY:ADMIN.DATASETUP.ICD10',
        VIEW: 'ADMIN.DATASETUP.ICD10.VIEW',
        ADD: 'ADMIN.DATASETUP.ICD10.ADD',
        EDIT: 'ADMIN.DATASETUP.ICD10.EDIT',
        DELETE: 'ADMIN.DATASETUP.ICD10.DELETE'
      },
      PHYSICIANS: {
        ANY: 'ANY:ADMIN.DATASETUP.PHYSICIANS',
        VIEW: 'ADMIN.DATASETUP.PHYSICIANS.VIEW',
        ADD: 'ADMIN.DATASETUP.PHYSICIANS.ADD',
        EDIT: 'ADMIN.DATASETUP.PHYSICIANS.EDIT',
        DELETE: 'ADMIN.DATASETUP.PHYSICIANS.DELETE'
      },
      PAYERS: {
        ANY: 'ANY:ADMIN.DATASETUP.PAYERS',
        VIEW: 'ADMIN.DATASETUP.PAYERS.VIEW',
        ADD: 'ADMIN.DATASETUP.PAYERS.ADD',
        EDIT: 'ADMIN.DATASETUP.PAYERS.EDIT',
        DELETE: 'ADMIN.DATASETUP.PAYERS.DELETE'
      },
      LOOKUPS: {
        ANY: 'ANY:ADMIN.DATASETUP.LOOKUPS',
        VIEW: 'ADMIN.DATASETUP.LOOKUPS.VIEW',
        ADD: 'ADMIN.DATASETUP.LOOKUPS.ADD',
        EDIT: 'ADMIN.DATASETUP.LOOKUPS.EDIT',
        DELETE: 'ADMIN.DATASETUP.LOOKUPS.DELETE'
      },
      SKILLS: {
        ANY: 'ANY:ADMIN.DATASETUP.SKILLS',
        VIEW: 'ADMIN.DATASETUP.SKILLS.VIEW',
        ADD: 'ADMIN.DATASETUP.SKILLS.ADD',
        EDIT: 'ADMIN.DATASETUP.SKILLS.EDIT',
        DELETE: 'ADMIN.DATASETUP.SKILLS.DELETE'
      },
      HCPCS: {
        ANY: 'ANY:ADMIN.DATASETUP.HCPCS',
        VIEW: 'ADMIN.DATASETUP.HCPCS.VIEW',
        ADD: 'ADMIN.DATASETUP.HCPCS.ADD',
        EDIT: 'ADMIN.DATASETUP.HCPCS.EDIT',
        DELETE: 'ADMIN.DATASETUP.HCPCS.DELETE'
      },
      RECEIVERS: {
        ANY: 'ANY:ADMIN.DATASETUP.RECEIVERS',
        VIEW: 'ADMIN.DATASETUP.RECEIVERS.VIEW',
        ADD: 'ADMIN.DATASETUP.RECEIVERS.ADD',
        EDIT: 'ADMIN.DATASETUP.RECEIVERS.EDIT',
        DELETE: 'ADMIN.DATASETUP.RECEIVERS.DELETE'
      },
      PLANS: {
        ANY: 'ANY:ADMIN.DATASETUP.PLANS',
        VIEW: 'ADMIN.DATASETUP.PLANS.VIEW',
        ADD: 'ADMIN.DATASETUP.PLANS.ADD',
        EDIT: 'ADMIN.DATASETUP.PLANS.EDIT',
        DELETE: 'ADMIN.DATASETUP.PLANS.DELETE'
      },
      PROGRAMS: {
        ANY: 'ANY:ADMIN.DATASETUP.PROGRAMS',
        VIEW: 'ADMIN.DATASETUP.PROGRAMS.VIEW',
        ADD: 'ADMIN.DATASETUP.PROGRAMS.ADD',
        EDIT: 'ADMIN.DATASETUP.PROGRAMS.EDIT',
        DELETE: 'ADMIN.DATASETUP.PROGRAMS.DELETE'
      },
      AGREEMENTS: {
        ANY: 'ANY:ADMIN.DATASETUP.AGREEMENTS',
        VIEW: 'ADMIN.DATASETUP.AGREEMENTS.VIEW',
        ADD: 'ADMIN.DATASETUP.AGREEMENTS.ADD',
        EDIT: 'ADMIN.DATASETUP.AGREEMENTS.EDIT',
        DELETE: 'ADMIN.DATASETUP.AGREEMENTS.DELETE'
      },
      MESSAGEBOARD: {
        ANY: 'ANY:ADMIN.DATASETUP.MESSAGEBOARD',
        VIEW: 'ADMIN.DATASETUP.MESSAGEBOARD.VIEW',
        ADD: 'ADMIN.DATASETUP.MESSAGEBOARD.ADD',
        EDIT: 'ADMIN.DATASETUP.MESSAGEBOARD.EDIT',
        DELETE: 'ADMIN.DATASETUP.MESSAGEBOARD.DELETE'
      },
      CAHPSVENDOR: {
        ANY: 'ANY:ADMIN.DATASETUP.CAHPSVENDOR',
        VIEW: 'ADMIN.DATASETUP.CAHPSVENDOR.VIEW',
        ADD: 'ADMIN.DATASETUP.CAHPSVENDOR.ADD',
        EDIT: 'ADMIN.DATASETUP.CAHPSVENDOR.EDIT',
        DELETE: 'ADMIN.DATASETUP.CAHPSVENDOR.DELETE'
      },
      CHARTDEFINITIONS: {
        ANY: 'ANY:ADMIN.DATASETUP.CHARTDEFINITIONS',
        VIEW: 'ADMIN.DATASETUP.CHARTDEFINITIONS.VIEW',
        ADD: 'ADMIN.DATASETUP.CHARTDEFINITIONS.ADD',
        EDIT: 'ADMIN.DATASETUP.CHARTDEFINITIONS.EDIT',
        DELETE: 'ADMIN.DATASETUP.CHARTDEFINITIONS.DELETE'
      }
    },
    DOCUMENTS: {
      ANY: 'ANY:ADMIN.DOCUMENTS',
      ACCOUNTDEFINITIONS: {
        ANY: 'ANY:ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS',
        ADD: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.ADD',
        EDIT: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.EDIT',
        DELETE: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.DELETE',
        VIEW: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.VIEW'
      },
      ACCOUNTDEFINITIONSETS: {
        ANY: 'ANY:ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS',
        ADD: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.ADD',
        EDIT: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.EDIT',
        MANAGE: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.MANAGE',
        DELETE: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.DELETE',
        VIEW: 'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.VIEW'
      },
      PATIENTDEFINITIONS: {
        ANY: 'ANY:ADMIN.DOCUMENTS.PATIENTDEFINITIONS',
        ADD: 'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.ADD',
        EDIT: 'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.EDIT',
        DELETE: 'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.DELETE',
        VIEW: 'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.VIEW'
      }
    },
    SALESTEAM: {
      ANY: 'ANY:ADMIN.SALESTEAM',
      SALESGROUPS: {
        ANY: 'ANY:ADMIN.SALESTEAM.SALESGROUPS',
        VIEW: 'ADMIN.SALESTEAM.SALESGROUPS.VIEW',
        ADD: 'ADMIN.SALESTEAM.SALESGROUPS.ADD',
        EDIT: 'ADMIN.SALESTEAM.SALESGROUPS.EDIT',
        DELETE: 'ADMIN.SALESTEAM.SALESGROUPS.DELETE'
      }
    },
    TOOLS: {
      ANY: 'ANY:ADMIN.TOOLS',
      BILLINGCYCLES: {
        ANY: 'ANY:ADMIN.TOOLS.BILLINGCYCLES',
        ADD: 'ADMIN.TOOLS.BILLINGCYCLES.ADD',
        EDIT: 'ADMIN.TOOLS.BILLINGCYCLES.EDIT',
        DELETE: 'ADMIN.TOOLS.BILLINGCYCLES.DELETE',
        VIEW: 'ADMIN.TOOLS.BILLINGCYCLES.VIEW'
      },
      AUDIT: {
        ANY: 'ANY:ADMIN.TOOLS.AUDIT',
        VIEW: 'ADMIN.TOOLS.AUDIT.VIEW'
      }
    },
    DESIGN: {
      ANY: 'ANY:ADMIN.DESIGN',
      EVENTS: {
        ANY: 'ANY:ADMIN.DESIGN.EVENTS',
        CHART: {
          ANY: 'ANY:ADMIN.DESIGN.EVENTS.CHART',
          VIEW: 'ADMIN.DESIGN.EVENTS.CHART.VIEW',
          ADD: 'ADMIN.DESIGN.EVENTS.CHART.ADD',
          EDIT: 'ADMIN.DESIGN.EVENTS.CHART.EDIT',
          DELETE: 'ADMIN.DESIGN.EVENTS.CHART.DELETE'
        },
        OFFICE: {
          ANY: 'ANY:ADMIN.DESIGN.EVENTS.OFFICE',
          VIEW: 'ADMIN.DESIGN.EVENTS.OFFICE.VIEW',
          ADD: 'ADMIN.DESIGN.EVENTS.OFFICE.ADD',
          EDIT: 'ADMIN.DESIGN.EVENTS.OFFICE.EDIT',
          DELETE: 'ADMIN.DESIGN.EVENTS.OFFICE.DELETE'
        }
      },
      WORKFLOWS: {
        ANY: 'ANY:ADMIN.DESIGN.WORKFLOWS',
        VIEW: 'ADMIN.DESIGN.WORKFLOWS.VIEW'
      },
      REPORTDEFINITIONS: {
        ANY: 'ANY:ADMIN.DESIGN.REPORTDEFINITIONS',
        VIEW: 'ADMIN.DESIGN.REPORTDEFINITIONS.VIEW',
        ADD: 'ADMIN.DESIGN.REPORTDEFINITIONS.ADD',
        EDIT: 'ADMIN.DESIGN.REPORTDEFINITIONS.EDIT',
        DELETE: 'ADMIN.DESIGN.REPORTDEFINITIONS.DELETE'
      },
      DASHBOARDWIDGETDEFINITIONS: {
        ANY: 'ANY:ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS',
        VIEW: 'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.VIEW',
        ADD: 'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.ADD',
        EDIT: 'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.EDIT',
        DELETE: 'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.DELETE'
      },
      OASIS: {
        ANY: 'ANY:ADMIN.DESIGN.OASISELEVATE',
        VIEW: 'ADMIN.DESIGN.OASISELEVATE.VIEW',
        ADD: 'ADMIN.DESIGN.OASISELEVATE.ADD',
        EDIT: 'ADMIN.DESIGN.OASISELEVATE.EDIT',
        DELETE: 'ADMIN.DESIGN.OASISELEVATE.DELETE'
      }
    },
    ALL: [
      'ADMIN.MANAGEACCESS.AGENCIES.VIEW',
      'ADMIN.MANAGEACCESS.AGENCIES.ADD',
      'ADMIN.MANAGEACCESS.AGENCIES.EDIT',
      'ADMIN.MANAGEACCESS.AGENCIES.DELETE',
      'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.VIEW',
      'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.ADD',
      'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.EDIT',
      'ADMIN.MANAGEACCESS.AGENCIES.LICENSES.DELETE',
      'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.VIEW',
      'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.ADD',
      'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.EDIT',
      'ADMIN.MANAGEACCESS.AGENCIES.CONTRACTS.DELETE',
      'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.VIEW',
      'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.ADD',
      'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.EDIT',
      'ADMIN.MANAGEACCESS.AGENCIES.INVOICES.DELETE',
      'ADMIN.MANAGEACCESS.ACCOUNTS.VIEW',
      'ADMIN.MANAGEACCESS.ACCOUNTS.ADD',
      'ADMIN.MANAGEACCESS.ACCOUNTS.EDIT',
      'ADMIN.MANAGEACCESS.ACCOUNTS.DELETE',
      'ADMIN.MANAGEACCESS.ACCOUNTS.ROLES.VIEW',
      'ADMIN.MANAGEACCESS.ACCOUNTS.ROLES.MANAGE',
      'ADMIN.MANAGEACCESS.ACCOUNTS.SESSIONS.VIEW',
      'ADMIN.MANAGEACCESS.ACCOUNTS.SESSIONS.MANAGE',
      'ADMIN.MANAGEACCESS.ROLES.VIEW',
      'ADMIN.MANAGEACCESS.ROLES.ADD',
      'ADMIN.MANAGEACCESS.ROLES.EDIT',
      'ADMIN.MANAGEACCESS.ROLES.DELETE',
      'ADMIN.MANAGEACCESS.PERMISSIONS.VIEW',
      'ADMIN.MANAGEACCESS.PERMISSIONS.MANAGE',
      'ADMIN.MANAGEACCESS.PERMISSIONS.ADD',
      'ADMIN.MANAGEACCESS.PERMISSIONS.EDIT',
      'ADMIN.DATASETUP.COUNTRIES.VIEW',
      'ADMIN.DATASETUP.COUNTRIES.ADD',
      'ADMIN.DATASETUP.COUNTRIES.EDIT',
      'ADMIN.DATASETUP.COUNTRIES.DELETE',
      'ADMIN.DATASETUP.STATES.VIEW',
      'ADMIN.DATASETUP.STATES.ADD',
      'ADMIN.DATASETUP.STATES.EDIT',
      'ADMIN.DATASETUP.STATES.DELETE',
      'ADMIN.DATASETUP.TIMEZONES.VIEW',
      'ADMIN.DATASETUP.TIMEZONES.ADD',
      'ADMIN.DATASETUP.TIMEZONES.EDIT',
      'ADMIN.DATASETUP.TIMEZONES.DELETE',
      'ADMIN.DATASETUP.ZIPCODES.VIEW',
      'ADMIN.DATASETUP.ZIPCODES.ADD',
      'ADMIN.DATASETUP.ZIPCODES.EDIT',
      'ADMIN.DATASETUP.ZIPCODES.DELETE',
      'ADMIN.DATASETUP.ICD10.VIEW',
      'ADMIN.DATASETUP.ICD10.ADD',
      'ADMIN.DATASETUP.ICD10.EDIT',
      'ADMIN.DATASETUP.ICD10.DELETE',
      'ADMIN.DATASETUP.PHYSICIANS.VIEW',
      'ADMIN.DATASETUP.PHYSICIANS.ADD',
      'ADMIN.DATASETUP.PHYSICIANS.EDIT',
      'ADMIN.DATASETUP.PHYSICIANS.DELETE',
      'ADMIN.DATASETUP.PAYERS.VIEW',
      'ADMIN.DATASETUP.PAYERS.ADD',
      'ADMIN.DATASETUP.PAYERS.EDIT',
      'ADMIN.DATASETUP.PAYERS.DELETE',
      'ADMIN.DATASETUP.LOOKUPS.VIEW',
      'ADMIN.DATASETUP.LOOKUPS.ADD',
      'ADMIN.DATASETUP.LOOKUPS.EDIT',
      'ADMIN.DATASETUP.LOOKUPS.DELETE',
      'ADMIN.DATASETUP.SKILLS.VIEW',
      'ADMIN.DATASETUP.SKILLS.ADD',
      'ADMIN.DATASETUP.SKILLS.EDIT',
      'ADMIN.DATASETUP.SKILLS.DELETE',
      'ADMIN.DATASETUP.HCPCS.VIEW',
      'ADMIN.DATASETUP.HCPCS.ADD',
      'ADMIN.DATASETUP.HCPCS.EDIT',
      'ADMIN.DATASETUP.HCPCS.DELETE',
      'ADMIN.DATASETUP.RECEIVERS.VIEW',
      'ADMIN.DATASETUP.RECEIVERS.ADD',
      'ADMIN.DATASETUP.RECEIVERS.EDIT',
      'ADMIN.DATASETUP.RECEIVERS.DELETE',
      'ADMIN.DATASETUP.PLANS.VIEW',
      'ADMIN.DATASETUP.PLANS.ADD',
      'ADMIN.DATASETUP.PLANS.EDIT',
      'ADMIN.DATASETUP.PLANS.DELETE',
      'ADMIN.DATASETUP.PROGRAMS.VIEW',
      'ADMIN.DATASETUP.PROGRAMS.ADD',
      'ADMIN.DATASETUP.PROGRAMS.EDIT',
      'ADMIN.DATASETUP.PROGRAMS.DELETE',
      'ADMIN.DATASETUP.AGREEMENTS.VIEW',
      'ADMIN.DATASETUP.AGREEMENTS.ADD',
      'ADMIN.DATASETUP.AGREEMENTS.EDIT',
      'ADMIN.DATASETUP.AGREEMENTS.DELETE',
      'ADMIN.DATASETUP.MESSAGEBOARD.VIEW',
      'ADMIN.DATASETUP.MESSAGEBOARD.ADD',
      'ADMIN.DATASETUP.MESSAGEBOARD.EDIT',
      'ADMIN.DATASETUP.MESSAGEBOARD.DELETE',
      'ADMIN.DATASETUP.CAHPSVENDOR.VIEW',
      'ADMIN.DATASETUP.CAHPSVENDOR.ADD',
      'ADMIN.DATASETUP.CAHPSVENDOR.EDIT',
      'ADMIN.DATASETUP.CAHPSVENDOR.DELETE',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.ADD',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.EDIT',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.DELETE',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONS.VIEW',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.ADD',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.EDIT',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.MANAGE',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.DELETE',
      'ADMIN.DOCUMENTS.ACCOUNTDEFINITIONSETS.VIEW',
      'ADMIN.SALESTEAM.SALESGROUPS.VIEW',
      'ADMIN.SALESTEAM.SALESGROUPS.ADD',
      'ADMIN.SALESTEAM.SALESGROUPS.EDIT',
      'ADMIN.SALESTEAM.SALESGROUPS.DELETE',
      'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.ADD',
      'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.EDIT',
      'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.DELETE',
      'ADMIN.DOCUMENTS.PATIENTDEFINITIONS.VIEW',
      'ADMIN.TOOLS.BILLINGCYCLES.ADD',
      'ADMIN.TOOLS.BILLINGCYCLES.EDIT',
      'ADMIN.TOOLS.BILLINGCYCLES.DELETE',
      'ADMIN.TOOLS.BILLINGCYCLES.VIEW',
      'ADMIN.TOOLS.AUDIT.VIEW',
      'ADMIN.DATASETUP.CHARTDEFINITIONS.VIEW',
      'ADMIN.DATASETUP.CHARTDEFINITIONS.ADD',
      'ADMIN.DATASETUP.CHARTDEFINITIONS.EDIT',
      'ADMIN.DATASETUP.CHARTDEFINITIONS.DELETE',
      'ADMIN.DESIGN.EVENTS.CHART.VIEW',
      'ADMIN.DESIGN.EVENTS.CHART.ADD',
      'ADMIN.DESIGN.EVENTS.CHART.EDIT',
      'ADMIN.DESIGN.EVENTS.CHART.DELETE',
      'ADMIN.DESIGN.EVENTS.OFFICE.VIEW',
      'ADMIN.DESIGN.EVENTS.OFFICE.ADD',
      'ADMIN.DESIGN.EVENTS.OFFICE.EDIT',
      'ADMIN.DESIGN.EVENTS.OFFICE.DELETE',
      'ADMIN.DESIGN.WORKFLOWS.VIEW',
      'ADMIN.DESIGN.REPORTDEFINITIONS.VIEW',
      'ADMIN.DESIGN.REPORTDEFINITIONS.ADD',
      'ADMIN.DESIGN.REPORTDEFINITIONS.EDIT',
      'ADMIN.DESIGN.REPORTDEFINITIONS.DELETE',
      'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.VIEW',
      'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.ADD',
      'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.EDIT',
      'ADMIN.DESIGN.DASHBOARDWIDGETDEFINITIONS.DELETE'
    ]
  }
}
